<ng-container *transloco="let convert;">
  <div class="d-flex date-range">
    <div class="flex-fill">
      <div class="datepicker-group">
        <div class="form-group date-label mb-0">
          <label class="control-label">{{convert('sellModule.manageInventory.utilityBarDateRange.labelFromDate')}}</label>
        </div>
        <div class="flex-grow-1">
          <div class="form-group d-flex date-group">
            <input
              type="text"
              class="form-control form-input"
              [formControl]="fromFormControl"
              [class.is-invalid]="!fromDateValid"
              #fromDp="ngbDatepicker"
              ngbDatepicker
              (dateSelect)="updateFromDate($event)"
              [value]="displayFromDate"
              #dpFromDate
              (input)="updateFromDate(dateFormatter.parse(dpFromDate.value))"
              [minDate]="fromMinDate"
              [maxDate]="fromMaxDate"
              [startDate]="fromStartDate"
              container="body"
              [attr.aria-label]="convert('sellModule.manageInventory.utilityBarDateRange.ariaLabelFromDate')"
              [placeholder]="dateFormatter.placeholderText()"
              (closed)="focusFromCalendar()"
              maxlength="10"
              minlength="10"
              [appTrack]="fromDateTrack.input"
              />
            <button
              #fromCalendar
              class="btn btn-outline-primary calendar-button"
              (click)="fromDp.toggle()"
              [attr.aria-expanded]="fromDp.isOpen()"
              [attr.aria-label]="convert('sellModule.manageInventory.utilityBarDateRange.ariaLabelFromDate')"
              [style.border-color]="!fromDateValid ? 'red' : ''"
              [appTrack]="fromDateTrack.button"
              >
              <i class="allycon-calendar" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="error-message from-date-error" aria-atomic="true" aria-live="polite" role="alert">
        @if (!fromDateValid) {
          <div><strong>{{convert('sellModule.manageInventory.utilityBarDateRange.textEnterValidFromDate')}}</strong></div>
        }
      </div>
    </div>
    <span class="p-2 to-text">{{convert('sellModule.manageInventory.utilityBarDateRange.textTo')}}</span>
    <div class="flex-fill">
      <div class="datepicker-group">
        <div class="form-group date-label mb-0">
          <label class="control-label">{{convert('sellModule.manageInventory.utilityBarDateRange.labelToDate')}}</label>
        </div>
        <div class="flex-grow-1">
          <div class="form-group d-flex date-group">
            <input
              type="text"
              class="form-control form-input to-date-input"
              [formControl]="toFormControl"
              [class.is-invalid]="!toDateValid"
              #toDp="ngbDatepicker"
              ngbDatepicker
              (dateSelect)="updateToDate($event)"
              [value]="displayToDate"
              #dpToDate
              (input)="updateToDate(dateFormatter.parse(dpToDate.value))"
              [minDate]="toMinDate"
              [maxDate]="toMaxDate"
              [startDate]="toStartDate"
              container="body"
              [attr.aria-label]="convert('sellModule.manageInventory.utilityBarDateRange.ariaLabelToDate')"
              [placeholder]="dateFormatter.placeholderText()"
              (closed)="focusToCalendar()"
              maxlength="10"
              minlength="10"
              [appTrack]="toDateTrack.input"
              />
            <button
              #toCalendar
              class="btn btn-outline-primary calendar-button"
              (click)="toDp.toggle()"
              [attr.aria-expanded]="toDp.isOpen()"
              [attr.aria-label]="convert('sellModule.manageInventory.utilityBarDateRange.ariaLabelToDate')"
              [style.border-color]="!toDateValid ? 'red' : ''"
              [appTrack]="toDateTrack.button"
              >
              <i class="allycon-calendar" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="error-message to-date-error" aria-atomic="true" aria-live="polite" role="alert">
        @if (!toDateValid) {
          <div><strong>{{convert('sellModule.manageInventory.utilityBarDateRange.textEnterValidToDate')}}</strong></div>
        }
      </div>
    </div>
  </div>
</ng-container>
